import { Component, Inject, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_959';

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Valor Efectivo', listHelp: ['742'] },
  { text: "2", active: false, completed: false, tooltip: 'Valor Inversiones', listHelp: ['744'] }
];

@Component({
  selector: 'app-renta-dividendos-nacional-modal',
  templateUrl: './renta-dividendos-nacional-modal.component.html',
  styleUrls: ['./renta-dividendos-nacional-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class RentaDividendosNacionalModalComponent extends HandlerModal implements OnInit {

  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  showSave:boolean = false;

  constructor(
    public dutilidades:DOperacionesMatematicasServicio, 
    public dialogRef: MatDialogRef<RentaDividendosNacionalModalComponent>,
    public dNotificacionServicio: DNotificacionServicio,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    console.log(model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.validateBtnRightActive();
    this.validateShowSave();
  }
  
  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cs_id_742 == undefined)this.model.doc.cuerpo.cs_id_742="0";
    if(this.model.doc.cuerpo.cs_id_743 == undefined)this.model.doc.cuerpo.cs_id_743="0";
    if(this.model.doc.cuerpo.cs_id_744 == undefined)this.model.doc.cuerpo.cs_id_744="0";
    if(this.model.doc.cuerpo.cs_id_745 == undefined)this.model.doc.cuerpo.cs_id_745="0";
  }

  
  public operaciones(numCas?:number,soloEstaCasilla?:boolean):void {
    switch (numCas) {
      case 742:
        this.operacionCs742();
        break;
      case 743:
        this.operacionCs743();
        break;
      case 744:
        this.operacionCs744();
        break;
      case 745:
        this.operacionCs745();
        break;
    }
    if(soloEstaCasilla)return;

    //Operaciones
    let resultado = "0";
    
  }

  operacionCs742(){
    this.model.doc.cuerpo.cs_id_742 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_742,true);
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_742, "0")){
      this.model.doc.cuerpo.cs_id_743 = "0";
    }
  }
  operacionCs743(){
    this.model.doc.cuerpo.cs_id_743 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_743,true);
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_743, this.model.doc.cuerpo.cs_id_742)){
      this.dNotificacionServicio.mostrarDialogoInformacion('El valor gravado en cabeza de la sociedad no puede ser mayor al valor recibido por utilidades generadas durante 2016 y años anteriores');
      this.model.doc.cuerpo.cs_id_743 = this.model.doc.cuerpo.cs_id_742;
    };
  }
  operacionCs744(){
    this.model.doc.cuerpo.cs_id_744 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_744,true);
  }
  operacionCs745(){
    this.model.doc.cuerpo.cs_id_745 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_745,true);
  }

  ///////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO que bloquean el avance
  public validateRbQuestions(val: string) {

  }
  
  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    
  }
  
  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateStepHabilitado(indexS:number):boolean{
    let habilitado = true;
    return habilitado;
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateBtnRightActive(){

  }

  //////////////////////////
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  protected updateIndicadorAvance(){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(this.indexStepper> Number(casIndicadorAvance)){
      let indexS = this.indexStepper+1;
      while(!this.validateStepHabilitado(indexS)){
        indexS++;
      }
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=indexS.toString();
    }
    if(this.indexStepper==this.stepsList.length-1){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
    }
  }

  protected controlStep(direction: DirectionType): void {
    this.changeStepLocal(this.indexStepper, true);
  }

  public changeStepLocal(index: number, forceUpdateStepper?:boolean){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(forceUpdateStepper){
      this.changeStep(index);
      this.updateIndicadorAvance();
    }else if(this.validateStepHabilitado(index)){
      let indexCalc = index-1;
      if(indexCalc<=Number(casIndicadorAvance)){
        this.changeStep(index);
        this.updateIndicadorAvance();
      }else{
        console.log("Avance no permitido: casIndicadorAvance=" + casIndicadorAvance + ", index-1="+(indexCalc));
      }
    }
    this.validateBtnRightActive();
    this.validateShowSave();
  }
  
  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ this.showSave=true };
  }
  
  public closeModal(){
    this.changeStepLocal(0);
    this.dialogRef.close("");
  }
  
  public guardar(){
    this.saveModel.emit(true);
    if(this.indexStepper==this.stepsList.length-1){
      this.closeModal();
    }
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/renta-dividendos/renta-dividendos-nacional-modal/renta-dividendos-nacional-modal.component.ts